import { handleActions } from 'redux-actions';

import {
  failureAddUserOption,
  failureRemoveUserOption,
  resetUserOptions,
  loadingUserOptions,
  successGetUserOptions,
  failureGetUserOptions,
  loadingAvailableOptions,
  successGetAvailableOptions,
  failureGetAvailableOptions,
  setSelectedOptionId,
  resetSubscriptionErrors,
  setSubscriptionPurchaseInProgress,
  loadingUserInvoices,
  setUserInvoices,
  failureGetUserInvoices,
  setPromoCode,
  resetPromoCode,
} from '@app/actions/subscribeActions';

const initialState = {
  isSubscriptionActive: false,
  isLoadingUserOptions: false,
  isLoadingOptions: false,
  isLoadingInvoices: false,
  isPurchaseInProgress: false,
  availableOptions: [],
  userOptions: [],
  invoices: [],
  selectedOptionId: null,
  promoCode: null,
  error: null,
};

export default handleActions({
  [loadingAvailableOptions]: state => ({
    ...state,
    isLoadingOptions: true,
  }),
  [successGetAvailableOptions]: (state, { payload }) => ({
    ...state,
    isLoadingOptions: false,
    availableOptions: payload,
  }),
  [failureGetAvailableOptions]: (state, { payload }) => ({
    ...state,
    isLoadingOptions: false,
    availableOptions: null,
    error: payload.error,
  }),
  [loadingUserOptions]: state => ({
    ...state,
    isLoadingUserOptions: true,
  }),
  [successGetUserOptions]: (state, { payload: { userOptions, isSubscriptionActive } }) => ({
    ...state,
    isLoadingUserOptions: false,
    isSubscriptionActive,
    userOptions,
  }),
  [failureGetUserOptions]: (state, { payload }) => ({
    ...state,
    isLoadingUserOptions: false,
    isSubscriptionActive: false,
    userOptions: [],
    error: payload,
  }),
  [setSubscriptionPurchaseInProgress]: (state, { payload }) => ({
    ...state,
    isPurchaseInProgress: payload,
  }),
  [failureAddUserOption]: (state, { payload }) => ({
    ...state,
    isPurchaseInProgress: false,
    error: payload.error,
  }),
  [failureRemoveUserOption]: (state, { payload }) => ({
    ...state,
    isPurchaseInProgress: false,
    error: payload.error,
  }),
  [resetUserOptions]: state => ({
    ...state,
    isLoadingUserOptions: false,
    isSubscriptionActive: false,
    selectedOptionId: null,
    userOptions: [],
    error: null,
  }),
  [resetSubscriptionErrors]: state => ({
    ...state,
    error: null,
  }),
  [setSelectedOptionId]: (state, { payload }) => ({
    ...state,
    selectedOptionId: payload,
  }),
  [loadingUserInvoices]: state => ({
    ...state,
    isLoadingInvoices: true,
  }),
  [setUserInvoices]: (state, { payload }) => ({
    ...state,
    invoices: payload,
    isLoadingInvoices: false,
    error: null,
  }),
  [failureGetUserInvoices]: (state, { payload }) => ({
    ...state,
    invoices: [],
    isLoadingInvoices: false,
    error: payload,
  }),
  [setPromoCode]: (state, { payload }) => ({
    ...state,
    promoCode: payload,
  }),
  [resetPromoCode]: state => ({
    ...state,
    promoCode: null,
  }),
}, initialState);
